import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { TranscriptionProvider } from './contexts/TranscriptionContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <TranscriptionProvider>
        <App />
      </TranscriptionProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();